export default function () {
  const getParsedPosts = (txt) => {
    var parser = new DOMParser();
    var html = parser.parseFromString(txt, "text/html");
    let articles = html.querySelectorAll(".article--big, .article");
    for (let i = 0; i < articles.length; i++) {
      const element = articles[i];
      element.classList.add(element.getAttribute("data-aoe"));
    }
    let posts = html.querySelector(".posts").innerHTML;
    if (articles.length < 4) {
      loadMore.remove();
    }

    return posts; // parser.parseFromString(posts, 'text/html');;
  };

  let offset = 4;
  const ajaxLoadMore = () => {
    let postsWrapper = document.querySelector(".posts");
    var request = new XMLHttpRequest();
    let url = window.location.href + "?offset=" + offset;
    request.open("GET", url, true);

    request.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        // Success!
        var resp = this.response;

        let newhtml = getParsedPosts(resp);
        postsWrapper.innerHTML += newhtml;
        offset += 4;
      }
    };

    request.onerror = function () {
      // There was a connection error of some sort
      alert("Błąd ładowania");
    };

    request.send();
  };
  let loadMore = document.querySelector(".load-more");
  if (!loadMore) {
    return;
  }
  loadMore.addEventListener("click", ajaxLoadMore);
}
